var _title, _desc, _defs, _use, _rect, _rect2, _use2, _g, _use3, _rect3, _rect4, _use4, _g2, _g3, _g4, _use5, _rect5, _use6, _g5, _rect6, _g6, _g7, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUv = function SvgUv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "206px",
    height: "90px",
    viewBox: "0 0 206 90",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Group 11 Copy")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    cx: "42.9775939%",
    cy: "37.2628945%",
    fx: "42.9775939%",
    fy: "37.2628945%",
    r: "63.3860162%",
    gradientTransform: "translate(0.429776,0.372629),scale(1.000000,0.700000),rotate(40.201258),translate(-0.429776,-0.372629)",
    id: "radialGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.5,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0.5,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-2",
    x: 0,
    y: 0,
    width: 42,
    height: 60,
    rx: 6
  }), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "42.9775939%",
    cy: "37.2628945%",
    fx: "42.9775939%",
    fy: "37.2628945%",
    r: "64.0956729%",
    gradientTransform: "translate(0.429776,0.372629),scale(1.000000,0.681818),rotate(40.946190),translate(-0.429776,-0.372629)",
    id: "radialGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.5,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0.5,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-4",
    x: 6,
    y: 10,
    width: 30,
    height: 44,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-5",
    x: 0,
    y: 0,
    width: 42,
    height: 60,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-6",
    x: 6,
    y: 10,
    width: 30,
    height: 44,
    rx: 1
  }), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "42.9775939%",
    cy: "37.2628945%",
    fx: "42.9775939%",
    fy: "37.2628945%",
    r: "60.8254444%",
    gradientTransform: "translate(0.429776,0.372629),scale(1.000000,0.777778),rotate(37.256359),translate(-0.429776,-0.372629)",
    id: "radialGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.5,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0.5,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-8",
    x: 0,
    y: 0,
    width: 70,
    height: 90,
    rx: 6
  }), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "42.9775939%",
    cy: "37.2628945%",
    fx: "42.9775939%",
    fy: "37.2628945%",
    r: "62.3230999%",
    gradientTransform: "translate(0.429776,0.372629),scale(1.000000,0.729730),rotate(39.030749),translate(-0.429776,-0.372629)",
    id: "radialGradient-9"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.5,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0.5,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-10",
    x: 2,
    y: 2,
    width: 54,
    height: 74,
    rx: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11-Copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    opacity: 0.200000003,
    transform: "translate(0.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-6"
  }, _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#A6A6A6",
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "url(#radialGradient-1)",
    style: {
      mixBlendMode: "overlay"
    },
    xlinkHref: "#path-2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-6",
    fill: "#FFFFFF",
    x: 4,
    y: 8,
    width: 34,
    height: 48,
    rx: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-6",
    fill: "#FFFFFF",
    x: 15,
    y: 3,
    width: 12,
    height: 2,
    rx: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-6"
  }, _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    fill: "#A6A6A6",
    xlinkHref: "#path-4"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "url(#radialGradient-3)",
    style: {
      mixBlendMode: "overlay"
    },
    xlinkHref: "#path-4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(16.000000, 23.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1,4 C1,1.790861 2.790861,0 5,0 C7.209139,0 9,1.790861 9,4 C9,6.209139 7.209139,8 5,8 C2.790861,8 1,6.209139 1,4 Z",
    id: "Combined-Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,14 L1.54043445e-14,13 C1.54043445e-14,10.2385763 2.23857625,8 5,8 C7.76142375,8 10,10.2385763 10,13 L10,14",
    id: "Path"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    opacity: 0.200000003,
    transform: "translate(164.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-6"
  }, _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    fill: "#A6A6A6",
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "url(#radialGradient-1)",
    style: {
      mixBlendMode: "overlay"
    },
    xlinkHref: "#path-5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-6",
    fill: "#FFFFFF",
    x: 4,
    y: 8,
    width: 34,
    height: 48,
    rx: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-6",
    fill: "#FFFFFF",
    x: 15,
    y: 3,
    width: 12,
    height: 2,
    rx: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-6"
  }, _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    fill: "#A6A6A6",
    xlinkHref: "#path-6"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "url(#radialGradient-3)",
    style: {
      mixBlendMode: "overlay"
    },
    xlinkHref: "#path-6"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(16.000000, 23.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1,4 C1,1.790861 2.790861,0 5,0 C7.209139,0 9,1.790861 9,4 C9,6.209139 7.209139,8 5,8 C2.790861,8 1,6.209139 1,4 Z",
    id: "Combined-Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,14 L1.54043445e-14,13 C1.54043445e-14,10.2385763 2.23857625,8 5,8 C7.76142375,8 10,10.2385763 10,13 L10,14",
    id: "Path"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(33.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-6",
    fill: "#A6A6A6",
    x: 0,
    y: 0,
    width: 52,
    height: 70,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-6",
    fill: "#D9D9D9",
    x: 4,
    y: 8,
    width: 44,
    height: 58,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-6",
    fill: "#D9D9D9",
    x: 20,
    y: 3,
    width: 12,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-6",
    fill: "#A6A6A6",
    x: 6,
    y: 10,
    width: 40,
    height: 54,
    rx: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(16.000000, 23.000000)",
    stroke: "#D9D9D9",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,8 C2,3.581722 5.581722,0 10,0 C14.418278,0 18,3.581722 18,8 C18,12.418278 14.418278,16 10,16 C5.581722,16 2,12.418278 2,8 Z",
    id: "Combined-Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,28 L3.08086889e-14,26 C3.08086889e-14,20.4771525 4.4771525,16 10,16 C15.5228475,16 20,20.4771525 20,26 L20,28",
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(13.000000, 22.000000)"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(121.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-6",
    fill: "#A6A6A6",
    x: 0,
    y: 0,
    width: 52,
    height: 70,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-6",
    fill: "#D9D9D9",
    x: 4,
    y: 8,
    width: 44,
    height: 58,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-6",
    fill: "#D9D9D9",
    x: 20,
    y: 3,
    width: 12,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-6",
    fill: "#A6A6A6",
    x: 6,
    y: 10,
    width: 40,
    height: 54,
    rx: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(16.000000, 23.000000)",
    stroke: "#D9D9D9",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,8 C2,3.581722 5.581722,0 10,0 C14.418278,0 18,3.581722 18,8 C18,12.418278 14.418278,16 10,16 C5.581722,16 2,12.418278 2,8 Z",
    id: "Combined-Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,28 L3.08086889e-14,26 C3.08086889e-14,20.4771525 4.4771525,16 10,16 C15.5228475,16 20,20.4771525 20,26 L20,28",
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(13.000000, 22.000000)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(68.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-6"
  }, _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    fill: "#272C36",
    xlinkHref: "#path-8"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "url(#radialGradient-7)",
    style: {
      mixBlendMode: "overlay"
    },
    xlinkHref: "#path-8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(6.000000, 6.000000)"
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-6",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 58,
    height: 78,
    rx: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-6"
  }, _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    fill: "#272C36",
    xlinkHref: "#path-10"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "url(#radialGradient-9)",
    style: {
      mixBlendMode: "overlay"
    },
    xlinkHref: "#path-10"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(8.000000, 16.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-6",
    x: 0,
    y: 0,
    width: 10,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-6",
    x: 32,
    y: 0,
    width: 10,
    height: 2,
    rx: 1
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-6",
    fill: "#FFFFFF",
    x: 0,
    y: 28,
    width: 58,
    height: 40
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(23.000000, 6.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1,5 C1,2.23857625 3.23857625,0 6,0 C8.76142375,0 11,2.23857625 11,5 C11,7.76142375 8.76142375,10 6,10 C3.23857625,10 1,7.76142375 1,5 Z",
    id: "Combined-Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,17 C1.84852134e-14,13.6862915 2.6862915,11 6,11 C9.3137085,11 12,13.6862915 12,17 L12,19 L0,19",
    id: "Path"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(20.000000, 29.000000)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17,56 L17,44 L21.2,44 L21.2,56 C21.2,57.1520058 21.6079959,58.1399959 22.424,58.964 C23.2400041,59.7880041 24.2319942,60.2 25.4,60.2 C26.5520058,60.2 27.5399959,59.7880041 28.364,58.964 C29.1880041,58.1399959 29.6,57.1520058 29.6,56 L29.6,44 L33.8,44 L33.8,56 C33.8,58.3200116 32.9800082,60.2999918 31.34,61.94 C29.6999918,63.5800082 27.7200116,64.4 25.4,64.4 C23.0799884,64.4 21.1000082,63.5800082 19.46,61.94 C17.8199918,60.2999918 17,58.3200116 17,56 Z M53.48,44 L46.256,63.8 L42.968,63.8 L35.744,44 L40.208,44 L44.6,56.048 L49.016,44 L53.48,44 Z",
    id: "UV",
    fill: "#272C36"
  }))))));
};
export { SvgUv as ReactComponent };
export default "/1d9e382652752581521279795d444fdb.svg";